const getLastSendTime = ({ analytic: { lastSend } }) => lastSend;
const getEvents = ({ analytic: { events } }) => events.filter(event => !event.pending).map(({ data }) => data);
const getPending = ({ analytic: { events } }) => events.filter(event => event.pending).map(({ data }) => data);

export default {
  getLastSendTime,
  getEvents,
  getPending,
};
